import { PropsWithChildren, createContext, memo, use, useState } from 'react';

import { Config } from '../types/schemas/documents/Config';

const createDefaultSiteSettings = (): Config => ({
	_id: '',
	_type: 'Config',
	unhandledErrorMessage: '',
	dismissButtonLabel: '',
	toastNotificationTimeout: 0,
});

type SiteSettingsContextValue = {
	siteSettings: Config;
	setSiteSettings: (siteSettings: Config) => void;
};

const SiteSettingsContext = createContext<SiteSettingsContextValue>({
	siteSettings: createDefaultSiteSettings(),
	setSiteSettings: () => {},
});

export const useSiteSettings = () => use(SiteSettingsContext);

export const SiteSettingsProvider = memo(({ children }: PropsWithChildren) => {
	const [siteSettings, setSiteSettings] = useState<Config>(createDefaultSiteSettings());

	return (
		<SiteSettingsContext
			value={{
				siteSettings,
				setSiteSettings,
			}}
		>
			{children}
		</SiteSettingsContext>
	);
});

SiteSettingsProvider.displayName = 'SiteSettingsProvider';
